import { ModelCollection } from "../../tools/abstract/mvc/Collections";
import { GameModel } from "./GameModel";

export var models = {
    game: new GameModel,
};